var render, staticRenderFns
import script from "./EspondiloartritesHypothesis.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesHypothesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a74070",
  null
  
)

export default component.exports